import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { change as changeAction } from 'redux-form';

import { List, FilterForm, Datagrid } from 'components/list/index';
import { TextField, MultipleChipsField, ImageField } from 'components/field/index';
import { EditButton, ShowButton } from 'components/button/index';

import { SelectInput } from 'components/input';

import { crudGetMeta as crudGetMetaAction } from 'actions/dataActions';

import { FILTER_FORM } from 'util/constants';
import * as urls from './urls';

// Template List
export const ShopTemplateListFilter = (props) => (
  <FilterForm name="shop_list_filter" {...props}>
  </FilterForm>
);

export const ShopTemplateList = (props) => (
  <List {...props} filters={<ShopTemplateListFilter/>}>
    <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
      <TextField source="id" label="ID"/>
      <TextField source="en" label="Name"/>
      <TextField source="translation" label="Name(Local)"/>
      <MultipleChipsField source="category_names" label="Categories"/>
      <EditButton linkTo={urls.shopTemplateEditFrontendPath} label="Edit"/>
    </Datagrid>
  </List>
);


// Category List
class ShopCategoryListFilter extends Component {

  static propTypes = {
    templateChoices: PropTypes.array,
  };

  static defaultProps = {
    templateChoices: []
  };

  render() {
    const { templateChoices } = this.props;
    return (
      <FilterForm name="shop_category_list_filter" {...this.props}>
        <SelectInput label="Template" source="template_id" choices={templateChoices}/>
      </FilterForm>
    );
  }
}


class ShopCategoryListBase extends Component {

  static propTypes = {
    crudGetMeta: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { resource, backendPath } = this.props;
    this.props.crudGetMeta(resource, backendPath, { meta: true });
  }

  render() {
    const templateChoices = this.props.meta['template_choices'];
    const filters = <ShopCategoryListFilter templateChoices={templateChoices}/>;
    return (
      <List {...this.props} filters={filters} sort={{ field: 'id', order: 'DESC' }} perPage={10}>
        <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
          <TextField source="id" label="ID"/>
          <TextField source="en" label="Name"/>
          <TextField source="translation" label="Name(Local)"/>
          <MultipleChipsField source="template_names" label="Templates"/>
          <EditButton linkTo={urls.shopCategoryEditFrontendPath} label="Edit"/>
          <ShowButton linkTo={urls.shopCategoryDetailFrontendPath} label="Detail"/>
        </Datagrid>
      </List>
    );
  }
}

const mapStateToProps = (state, props) => ({
  meta: state.admin[props.resource].meta,
});

export const ShopCategoryList = connect(mapStateToProps, { crudGetMeta: crudGetMetaAction })(ShopCategoryListBase);


// Item List

// Category List
class ShopItemListFilter extends Component {

  static propTypes = {
    meta: PropTypes.object.isRequired,
    changeForm: PropTypes.func.isRequired,
  };

  static defaultProps = {
    meta: {},
  };

  state = {
    templateChoices: [],
    categoryChoices: [],
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.meta !== this.props.meta) {
      const { meta } = nextProps;
      if (meta && meta['templates']) {
        this.setState({
          templateChoices: [{ id: '', name: '' }].concat(meta['templates'].map(t => ({ id: t.id, name: t.en })))
        })
      }
    }

  }

  templateOnChange = (_, value) => {
    if (value) {
      const templateId = parseInt(value, 10);
      const { templates, categories } = this.props.meta;
      let categoryIds = templates.find(t => t.id === templateId)['category_ids'].map(c => parseInt(c, 10));
      categoryIds = new Set(categoryIds);
      const categoryChoices = categories.filter(c => categoryIds.has(c.id)).map(c => ({ id: c.id, name: c.en }));
      this.setState({
        categoryChoices: [{ id: '', name: '' }].concat(categoryChoices)
      });
    }
    else {
      this.setState({
        categoryChoices: [],
      })
    }
    this.props.changeForm(FILTER_FORM, 'category_id', '');
  };

  render() {
    const { templateChoices, categoryChoices } = this.state;
    return (
      <FilterForm name="shop_item_list_filter" {...this.props}>
        <SelectInput label="Template" source="template_id" choices={templateChoices} onChange={this.templateOnChange}/>
        <SelectInput label="Category" source="category_id" choices={categoryChoices}/>
      </FilterForm>
    );
  }
}

class ShopItemListBase extends Component {

  static propTypes = {
    crudGetMeta: PropTypes.func.isRequired,
    changeForm: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { resource, backendPath } = this.props;
    this.props.crudGetMeta(resource, backendPath, { meta: true });
  }

  render() {
    const filters = <ShopItemListFilter meta={this.props.meta} changeForm={this.props.changeForm}/>;
    return (
      <List {...this.props} filters={filters}>
        <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
          <TextField source="id" label="ID"/>
          <TextField source="en" label="Name"/>
          <TextField source="translation" label="Name(Local)"/>
          <MultipleChipsField source="category_names" label="Category"/>
          <MultipleChipsField source="template_names" label="Templates"/>
          <ImageField source="tile_image_path" label="Image"/>
          <EditButton linkTo={urls.shopItemEditFrontendPath} label="Edit"/>
        </Datagrid>
      </List>
    );
  }
}

export const ShopItemList = connect(
  mapStateToProps,
  {
    crudGetMeta: crudGetMetaAction,
    changeForm: changeAction,
  }
)(ShopItemListBase);


// WEBPACK FOOTER //
// ./src/routes/shop/ShopTemplateList.js